import { TFunction } from 'react-i18next';
import * as Yup from 'yup';

import {
  otpRegularExpression,
  phoneNumberRegularExpression
} from '@nw/shared/utils';

export const UserAuthInputFieldValidationSchema = (
  t: TFunction
): Yup.AnyObjectSchema =>
  Yup.object({
    phoneNumber: Yup.string()
      .required(t('validationMessages.required'))
      .matches(
        phoneNumberRegularExpression,
        t('validationMessages.pleaseEnterAValidPhoneNumber')
      ),
    otp: Yup.string()
      .matches(otpRegularExpression, t('validationMessages.enterAValidOTP'))
      .required(t('validationMessages.required'))
  });
